import { IBalances } from '../types';
import { SubAccountType } from '../enums';
import { getSubAccountResponse } from './balance.utils';
import { validateFeatureFlag } from '../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../constants/general';
import { IGustoWidgetDataResponse } from '../../../hooks/query/useGetGustoDataForWidget';

export const shouldShowCheckingWidget = true;

export const shouldShowSavingWidget = (userBalances: IBalances) => (getSubAccountResponse(userBalances, SubAccountType.emergencySavings) != null);

export const showTaxBucketBalance = () => validateFeatureFlag(FEATURE_FLAG.TAX_BUCKET);
export const showEmergencyBucketBalance = () => validateFeatureFlag(FEATURE_FLAG.EMERGENCY_BUCKET);
export const showSavingBucketBalance = () => validateFeatureFlag(FEATURE_FLAG.EMERGENCY_SAVING_ACCOUNT);

export const shouldShowGustoWidget = (gustoData: IGustoWidgetDataResponse | undefined) => validateFeatureFlag(FEATURE_FLAG.Gusto) && ((gustoData?.nextPaymentDate && gustoData?.paymentAmount && gustoData?.gustoLink) || gustoData?.gustoError);
